var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-nav",attrs:{"id":"nav"}},[(!_vm.loggedIn)?_c('public-nav'):_c('authed-nav')],1)}
var staticRenderFns = []

export { render, staticRenderFns }